<template>
  <div class="animated fadeIn">
    <b-row class="mt-2 mb-2">
      <b-col>
        <h2>สร้างบริษัท</h2>
      </b-col>
      <b-col>
        <b-button class="float-right ml-4" variant="primary" @click="save">สร้างบริษัท</b-button>
        <b-button class="float-right" @click="goBack" variant="warning">ย้อนกลับ</b-button>
      </b-col>
    </b-row>
    <b-form>
      <b-row>
        <b-col md="12" lg="12">
          <b-card>
            <b-row>
              <b-col sm="12">
                <TextInput
                  :value="$v.form.companyName"
                  id="companyName"
                  feedback="จำเป็นต้องระบุ"
                  label="ชื่อบริษัท"
                  placeholder="ตัวอย่าง: ร่ำรวยขนส่ง"
                  :isRequired="true"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <TextInput
                  :value="$v.form.profileUrl"
                  id="profileUrl"
                  feedback="ระบุ permalink"
                  label="Permalink"
                  :isRequired="true"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <SelectInput
                  :value="$v.form.companyType"
                  id="companyType"
                  feedback="เลือกประเภท"
                  label="ประเภทบริษัท"
                  :options="companyTypeOptions"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <TextInput
                  :value="$v.form.email"
                  id="email"
                  feedback="ระบุอีเมล"
                  label="อีเมล"
                  :isRequired="true"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <TextInput
                  :value="$v.form.name"
                  id="userName"
                  feedback="ใส่ชื่อผู้ใช้งาน"
                  label="ชื่อ-นามสกุล"
                  placeholder="ตัวอย่าง: สมยศ ขนน้ำ"
                  :isRequired="true"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <TextInput
                  :value="$v.form.phoneNumber"
                  id="phoneNumber"
                  feedback="เบอร์โทรต้องขึ้นต้อนด้วย 0 และมี 10 หลักประกอบด้วย 0-9"
                  label="เบอร์โทรผู้ติดต่อ (login ได้)"
                  placeholder="ตัวอย่าง: 0812345678"
                  :isRequired="true"
                />
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-form>
    <b-row class="mt-2 mb-2">
      <b-col>
        <b-button class="float-right ml-4" variant="primary" @click="save">สร้างบริษัท</b-button>
        <b-button class="float-right" @click="goBack" variant="warning">ย้อนกลับ</b-button>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>
import ModalLoading from '../../../components/ModalLoading'

import { validationMixin } from 'vuelidate'
import { required, email, helpers, url } from 'vuelidate/lib/validators'

import TextInput from '../../../components/TextInput'
import SelectInput from '../../../components/SelectInput'

import Company from '../../../services/http/Company'

const thPhoneNumber = helpers.regex('thPhoneNumber', /^0[0-9]{9}$/)

export default {
  mixins: [validationMixin],
  components: {
    ModalLoading,
    TextInput,
    SelectInput
  },
  data () {
    return {
      form: {
        companyName: null,
        phoneNumber: null,
        email: null,
        companyType: null,
        profileUrl: null,
        name: null
      },
      companyTypeOptions: [
        { value: null, text: 'เลือก' },
        // { value: 'individual', text: 'บุคคลธรรมดา' },
        // { value: 'company', text: 'บริษัท' },
        { value: 'company-limited', text: 'บริษัทจำกัด' },
        { value: 'public-company-limited', text: 'บริษัท มหาชน จำกัด' },
        { value: 'limited-partnership', text: 'ห้างหุ้นส่วนจำกัด' }
      ]
    }
  },
  validations: {
    form: {
      companyName: {
        required
      },
      phoneNumber: {
        required,
        thPhoneNumber
      },
      email: {
        required,
        email
      },
      profileUrl: {
        required
      },
      companyType: {
        required
      },
      name: {
        required
      }
    }
  },
  methods: {
    async save () {
      this.$v.$touch()

      if (this.$v.$anyError) {
        return
      }

      Window.Event.$emit('showModalLoading')

      var company = new Company()
      try {
        var created = await company.createNewUserAndCompany(this.form)
        if (created.code === 1) {
          alert('สำเร็จ')
          this.$router.push({
            name: 'บริษัททั้งหมด'
          })
        } else {
          alert(created.message)
        }
      } catch (error) {
        console.log(error)
        alert(error.message)
      }
      Window.Event.$emit('closeModalLoading')
    },
    goBack () {
      this.$router.push({
        name: 'บริษัททั้งหมด'
      })
    }
  }
}
</script>
